import React from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Grid, Paper, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'

import { useAssociationStore } from '~/store/association/association-store'

import AssociationDataInfo from './components/association-data-info'
import AssociationMemberList from './components/association-member-list'
import { useStyles } from './style'

const AssocationInfo: React.FC = () => {
  const classes = useStyles()
  const { association } = useAssociationStore()
  const history = useHistory()

  return (
    <Grid item xs={12} className={classes.gridMain}>
      <Paper elevation={0} className={classes.paper}>
        <Grid container item xs={12}>
          <Grid item xs={1}>
            <Button
              variant="contained"
              color="primary"
              className={classes.iconBack}
              onClick={() => {
                history.goBack()
              }}
            >
              <ArrowBack />
            </Button>
          </Grid>
          <Grid item xs>
            <Typography variant="h4" color="primary">
              {association.association?.nome}
            </Typography>
          </Grid>
        </Grid>

        <Grid container item xs={12} style={{ paddingTop: '50px' }} spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <AssociationDataInfo />
              </Grid>
              <Grid item xs={12}>
                <AssociationMemberList userRequestFilter="associado=1" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default AssocationInfo
